import { render, staticRenderFns } from "./PhoneVerificationModal.vue?vue&type=template&id=6cd1e87c&"
import script from "./PhoneVerificationModal.vue?vue&type=script&lang=js&"
export * from "./PhoneVerificationModal.vue?vue&type=script&lang=js&"
import style0 from "./PhoneVerificationModal.vue?vue&type=style&index=0&id=6cd1e87c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports